import React, {Component} from 'react';
let Flickity = () => {};
import 'flickity/dist/flickity.css';

if (typeof window !== 'undefined') {
	Flickity = require('flickity-imagesloaded');
}

export default class FlickitySlideshow extends Component {
	constructor() {
		super();
	}

	componentDidMount = () => {
		if (!this.ref) return;
		
		this.slideshow = new Flickity(this.ref, this.props.options || {});
		
		if (this.props.sliderRef) this.props.sliderRef(this.slideshow);
	}

	componentWillUnmount = () => {
		this.slideshow && this.slideshow.destroy();
	}

	render() {
		const {
			children,
			options, // eslint-disable-line
			sliderRef, //eslint-disable-line
			...props
		} = this.props;
		return (
			<div
				{...props}
				ref={el => this.ref = el}>
				{children}
			</div>
		);
	}
}